<div class="modal fade" bsModal #prizeRedeemModal="bs-modal" tabindex="-1" role="dialog"
     aria-labelledby="prize-redeem-dialog" (onShown)="handleModalTrap('prizeRedeemModal')"
     (onHidden)="removeModalTrap('prizeRedeemModal')" data-tabindex="first" id="prizeRedeemModal">
    <div class="modal-dialog episodic-modal-dialog">
        <div class="modal-content">
            <div class="episodic-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closePrizeRedeemModal()">
                    <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
                </button>
            </div>
            <div *ngIf="prize != null" class="episodic-body pl-4 pr-4">
                <div role="heading" aria-level="2" id="prize-redeem-dialog" class="title-lg-bold episodic-body__title">
                    Redeem {{prize.burnPoints}} {{prize.burnPoints == 1 ? tokenLabelSingular : tokenLabelPlural}}
                </div>
                <div class="episodic-body__text">
                    Just double checking; redeeming can't be undone.
                </div>
            </div>
            <div class="episodic-footer pt-4 pb-0 pl-4 pr-4">
                <button [disabled]="isLoading" class="btn btn-xl btn-primary body-text episodic-footer__button" (click)="confirmRedeem()">
                    <ng-container *ngIf="isLoading === false else loadspinner">
                        Confirm
                    </ng-container>
                </button>
            </div>
            <div class="episodic-footer pt-0 pb-2 pl-4 pr-4">
                <div>
                    <button class="btn btn-xl" data-tabindex="last" (click)="closePrizeRedeemModal()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Address display Modal Starts -->
<div class="modal fade" bsModal #addressListModal="bs-modal" tabindex="-1" role="dialog"
    aria-labelledby="address list dialog" (onShown)="handleModalTrap('addressListModal')"
    (onHidden)="removeModalTrap('addressListModal')" id="addressListModal">
    <div class="modal-dialog episodic-modal-dialog">
        <div class="modal-content">
            <div class="episodic-header">
                <button type="button" class="close" data-tabindex="first" data-dismiss="modal" aria-label="Close" (click)="addressListModal.hide()">
                    <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
                </button>
            </div>
            <div class="episodic-body ">
                <div class="title-lg-bold episodic-body__title">
                    Select address
                </div>
                <div class="body-text-sm episodic-body__text ml-5 mr-5 mb-2">
                    We need your shipping information.
                </div>
                <div class="body-text-sm episodic-body__address multiple pt-2 pb-2">
                    <form #addressDetailsForm="ngForm" novalidate>
                        <div role="radiogroup">
                            <ng-container *ngFor="let address of addressDetails; let i = index;">
                                <div class="address_container pl-4 pr-4 pt-2 pb-2 mb-4"
                                    [attr.tabindex]="selectedIndex === i ? 0 : -1"
                                    (keydown)="keyDownRadioGroup($event, i)" [class.selected]="selectedIndex === i"
                                    (click)="selectAddress(i)" role="radio" [attr.aria-checked]="selectedIndex === i">
                                    <div class="address">
                                        <div class="address_container__name">
                                            {{address.firstName}}&nbsp;{{address.lastName}}</div>
                                        <div class="address_container__address">{{address.address}}</div>
                                        <div class="address_container__area">{{address.city}}, {{address.state}}
                                            {{address.zipCode}}
                                        </div>
                                    </div>
                                    <div class="radioButton">
                                        <div class="radioButton__group">
                                            <input class="radioButton__input" tabindex="-1" type="radio"
                                                [id]="address.addressId" [name]="selectedAddress.name"
                                                [(ngModel)]="selectedAddress.value" [value]="address.addressId"
                                                [checked]="selectedIndex === i">
                                            <label [for]="address.addressId"
                                                class="radioButton__label radioButton__label--lg body-text"></label>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="addressDetails.length === 0">
                            <p class="no-address">You have no saved delivery addresses.</p>
                        </ng-container>
                    </form>
                </div>
            </div>
            <div class="episodic-footer pt-3 pb-4">
                <button class="btn btn-xl btn-primary" (click)="callRedeemAPI()"
                    [disabled]="addressDetails.length === 0 || selectedAddress.value === ''"
                    [attr.data-tabindex]="addressDetails.length === 0 || selectedAddress.value === '' ? '' : 'last'">
                    <ng-container *ngIf="isLoading === false else loadspinner">
                        Confirm
                    </ng-container>
                </button>
                <a class="links__action underline link-reg" href="javascript:;"
                    [ngClass]="{'inactive':addressDetails.length === 13}" (click)="showAddNewAddress()"
                    [attr.data-tabindex]="addressDetails.length === 13 ? '' : 'last'">Add
                    a
                    new
                    address</a>
            </div>
        </div>
    </div>
</div>
<!-- Address display Modal Ends -->

<!-- Address form Modal starts -->
<div class="modal fade" bsModal #addressFormModal="bs-modal" tabindex="-1" role="dialog"
    aria-labelledby="address form dialog" (onShown)="handleModalTrap('addressFormModal')"
    (onHidden)="removeModalTrap('addressFormModal')" id="addressFormModal">
    <div class="modal-dialog episodic-modal-dialog">
        <div class="modal-content">
            <div class="episodic-header">
                <button type="button" class="svg-icon svg-forward episodic-modal-back"  data-tabindex="first" aria-label="back"
                    (click)="backToAddressList(addressForm)"></button>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeAddressFormModal(addressForm)">
                    <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
                </button>
            </div>
            <div class="episodic-body">
                <div class="title-lg-bold episodic-body__title">
                    Add Address
                </div>
                <div class="body-text-sm episodic-body__text ml-5 mr-5 mb-4">
                    We need your shipping information.
                </div>
                <form #addressForm="ngForm" novalidate>
                    <div class="body-text-sm episodic-body__addressform ml-1 mr-1 mb-4">
                        <div class="two-column">
                            <div class="input-field">
                                <div class="input-field__wrapper">
                                    <label for="div-firstname" class="input-field__float-label">
                                        <input type="text" minlength="2" disabled id="div-firstname" maxlength="30"
                                            autocomplete="off" #firstname="ngModel" pattern="^[a-zA-Z][\'\. a-zA-Z-]*$"
                                            required name="firstname" [(ngModel)]="userData.firstName"
                                            aria-label="First Name" />
                                        <span>First name</span>
                                    </label>
                                </div>
                            </div>
                            <div class="input-field">
                                <div class="input-field__wrapper">
                                    <label for="div-lastname" class="input-field__float-label">
                                        <input type="text" id="div-lastname" disabled minlength="2" maxlength="30"
                                            autocomplete="off" #lastname="ngModel" pattern="^[a-zA-Z][\'\. a-zA-Z-]*$"
                                            required name="lastname" [(ngModel)]="userData.lastName"
                                            aria-label="Last Name" />
                                        <span>Last name</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="address_container">
                            <div class="input-field">
                                <div class="input-field__wrapper"
                                    [class.input-field--error]="address.invalid && address.touched && address.errors">
                                    <label for="div-address" class="input-field__float-label">
                                        <input type="text" id="div-address" #address="ngModel" autocomplete="off"
                                            required name="address"
                                            pattern="^[^\s]*[0-9]{1,}[ ?][\sa-zA-Z0-9\'\.\,]*[^\s](\s?#\w{1,})?$"
                                            [(ngModel)]="userData.address" aria-label="Address" />
                                        <span>Address</span>
                                    </label>
                                </div>
                                <div *ngIf="address.invalid && address.touched && address.errors"
                                    class="input-field__help-text body-text-xs">
                                    <div class="input-field__help-text--error">
                                        <ul class="list-unstyled">
                                            <li *ngIf="address.errors.required">Please enter Address.</li>
                                            <li *ngIf="address.errors.pattern">Please enter valid Address.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="input-field">
                            <div class="input-field__wrapper"
                                [class.input-field--error]="zipcode.invalid && zipcode.touched && zipcode.errors">
                                <label for="div-zipcode" class="input-field__float-label">
                                    <input type="text" id="div-zipcode" #zipcode="ngModel" autocomplete="off"
                                        pattern="^[0-9]{5}$" maxlength="5" (input)="validateZipCode($event)"
                                        minlength="2" required name="zipcode" [(ngModel)]="userData.zipcode"
                                        aria-label="Zip Code" />
                                    <span>Zip code</span>
                                </label>
                            </div>
                            <div *ngIf="zipcode.invalid && zipcode.touched && zipcode.errors"
                                class="input-field__help-text body-text-xs">
                                <div class="input-field__help-text--error">
                                    <ul class="list-unstyled">
                                        <li *ngIf="zipcode.errors.required">Please enter ZIP Code.</li>
                                        <li *ngIf="zipcode.errors.pattern">Please enter a ZIP Code that contains only
                                            5 numbers.</li>
                                    </ul>
                                </div>
                            </div>
                            <div *ngIf="invalidZipcode"
                                class="input-field__help-text body-text-xs">
                                <div class="input-field__help-text--error">
                                    <ul class="list-unstyled">
                                        <li >Please enter a valid ZIP Code.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="two-column">
                            <div class="input-field">
                                <div class="input-field__wrapper"
                                    [class.input-field--error]="city.invalid && city.touched && city.errors">
                                    <label for="div-city" class="input-field__float-label">
                                        <input type="text" id="div-city" #city="ngModel" autocomplete="off" required
                                            name="city" [(ngModel)]="userData.city" pattern="[a-zA-Z][\'\. a-zA-Z-]*$"
                                            aria-label="City" />
                                        <span>City</span>
                                    </label>
                                </div>
                                <div *ngIf="city.invalid && city.touched && city.errors"
                                    class="input-field__help-text body-text-xs">
                                    <div class="input-field__help-text--error">
                                        <ul class="list-unstyled">
                                            <li *ngIf="city.errors.required || city.errors.pattern">Please enter valid
                                                city.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="input-field">
                                <div class="input-field__wrapper text-dropdown"
                                    [class.input-field--error]="state.invalid && state.touched && state.errors">
                                    <label for="div-state" class="input-field__float-label">
                                        <select class="form-control" id="div-state" [(ngModel)]="userData.state"
                                            aria-label="State" #state="ngModel" disabled autocomplete="off" required name="state"
                                            tabindex="0">
                                            <option *ngFor="let item of states" [value]="item.value">{{item.name}}
                                            </option>
                                        </select>
                                        <span>State</span>
                                    </label>
                                </div>
                                <div *ngIf="state.invalid && state.touched && state.errors"
                                    class="input-field__help-text body-text-xs">
                                    <div class="input-field__help-text--error">
                                        <ul class="list-unstyled">
                                            <li *ngIf="state.errors.required">Please select
                                                valid state</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="episodic-footer no-gap">
                <div [ngClass]="addressFormErrorMsg === '' ? 'invisible' : 'visible'"
                    class="body-text-sm input-field__help-text--error ml-5 mr-5 mb-4">{{addressFormErrorMsg}}</div>
                <button class="btn btn-xl btn-primary" data-tabindex="last" 
                    [disabled]="address.errors || zipcode.errors || city.errors || state.errors || invalidZipcode" (click)="onSubmit()">
                    <ng-container *ngIf="isLoading === false else loadspinner">
                        Add Address
                    </ng-container>
                </button>
            </div>
        </div>
    </div>
</div>
<!-- Address form Modal ends -->

<!-- Redeem Success Modal Starts -->
<div class="modal fade" bsModal #redeemConfirmSuccessModal="bs-modal" tabindex="-1" role="dialog"
    aria-labelledby="redeem confirm success dialog" data-tabindex="first" (onShown)="handleModalTrap('redeemConfirmSuccessModal')"
    (onHidden)="removeModalTrap('redeemConfirmSuccessModal')" id="redeemConfirmSuccessModal">
    <div class="modal-dialog episodic-modal-dialog">
        <div class="modal-content">
            <div class="episodic-header">
            </div>
            <div class="episodic-game-logo">
                <ng-container *ngIf="prize && prize['prizeId']">
                    <picture>
                        <source media="(min-width: {{md}})" srcset="{{getImageUrl(prize,'desktop')}}">
                        <source media="(min-width: {{sm}})" srcset="{{getImageUrl(prize,'tablet')}}">
                        <img loading="lazy" class="prize-image" src="{{getImageUrl(prize,'mobile')}}"
                            alt="" />
                    </picture>
                </ng-container>
            </div>
            <div class="episodic-body" pl-4 pr-4>
                <div class="title-lg-bold episodic-body__title" [ngSwitch]="prize && prize.type">
                    <ng-container *ngSwitchCase="prizetypes.VENDOR">
                        You will receive your item in approximately 6-8 weeks after your order is processed. Subject to verification.
                    </ng-container>
                    <ng-container *ngSwitchCase="prizetypes.SWEEPSTAKES">
                        Your entry has been added to your account!
                    </ng-container>
                    <ng-container *ngSwitchCase="prizetypes.B4U_OFFER">
                        Your coupon has been added to your account!
                    </ng-container>
                    <ng-container *ngSwitchCase="prizetypes.REWARD">
                        Your reward has been added to your account!
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <ng-container *ngIf="prize && prize.digitalPrize">
                            Your redemption has been added to your account!
                        </ng-container>
                        <ng-container *ngIf="prize && !prize.digitalPrize">
                            Your redemption is on its way!
                        </ng-container>                        
                    </ng-container>
                </div>
            </div>
            <div class="episodic-footer pt-3 pb-4 pl-4 pr-4">
                <button class="btn btn-xl btn-primary" data-tabindex="last" (click)="closeAndRefresh()">Got it</button>
            </div>
        </div>
    </div>
</div>
<!-- Redeem Success Modal Ends -->


<!-- Error Modal Begins -->
<div class="modal fade" bsModal #redeemErrorModal="bs-modal" tabindex="-1" role="dialog"
    aria-labelledby="redeem error dialog" (onShown)="handleModalTrap('redeemErrorModal')"
    (onHidden)="removeModalTrap('redeemErrorModal')" id="redeemErrorModal">
    <div class="modal-dialog episodic-modal-dialog">
        <div class="modal-content">
            <div class="episodic-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="redeemErrorModal.hide()">
                    <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
                </button>
            </div>
            <div class="episodic-warning">
                <span class="svg-warning-outline"></span>
            </div>
            <div class="episodic-body pl-4 pr-4">
                <div class="title-lg-bold episodic-body__title">
                    There was an issue
                </div>
                <div class="episodic-body__text">
                    There was a technical issue. Please retry
                </div>
            </div>
            <div class="episodic-footer pt-3 pb-4 pl-4 pr-4">
                <button class="btn btn-xl btn-primary body-text episodic-footer__button" aria-label="Retry"
                    (click)="retryRedeem()">Retry</button>
            </div>
        </div>
    </div>
</div>
<!-- Error Modal Ends -->


<!-- Loading Spinner -->
<ng-template #loadspinner>
    <div alt="Loading..." class="small progress">
        <div class="prog1">
            <div class="prog2"></div>
        </div>
    </div>
</ng-template>